export function parametrify(obj: object)
{
    return Object.keys(obj)
        .filter(k => obj[k] !== undefined)
        .reduce((p, c) => ({ ...p, [c]: typeof obj[c] === 'string' || Array.isArray(obj[c]) ? obj[c] : JSON.stringify(obj[c]) }), { });
}
